<template>
  <div class="card p-shadow-app">
    <h1>Acessórios de Recepção</h1>
    <Toast />
    <ConfirmDialog />

    <div class="p-mb-3 p-d-flex p-jc-between p-ai-center">
      <Button
        label="Novo Acessório"
        icon="pi pi-plus"
        class="p-button-success"
        @click="openNew"
      />
    </div>

    <DataTable
      :value="accessories"
      :loading="loading"
      responsiveLayout="scroll"
      class="p-datatable-sm"
      stripedRows
    >
      <template #empty>
        <div class="p-text-center p-p-3">
          <p class="p-mt-2">Nenhum acessório encontrado</p>
        </div>
      </template>

      <Column field="code" header="Código" :sortable="true" style="min-width: 150px" />
      <Column field="name" header="Nome" :sortable="true" style="min-width: 200px" />
      <Column header="Ações" style="width: 150px">
        <template #body="slotProps">
          <Button
            icon="pi pi-pencil"
            class="p-button-rounded p-button-info p-button-text"
            v-tooltip.top="'Editar'"
            @click="openEdit(slotProps.data)"
          />
          <Button
            icon="pi pi-trash"
            class="p-button-rounded p-button-danger p-button-text"
            v-tooltip.top="'Eliminar'"
            @click="confirmDelete(slotProps.data)"
          />
        </template>
      </Column>
    </DataTable>

    <Dialog
      :visible.sync="showDialog"
      :header="editingId ? 'Editar Acessório' : 'Novo Acessório'"
      :modal="true"
      :closable="true"
      :style="{ width: '450px' }"
    >
      <div class="p-fluid">
        <div class="p-field">
          <label for="name">Nome</label>
          <InputText id="name" v-model="form.name" class="p-inputtext-sm" />
        </div>
      </div>

      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-text"
          @click="showDialog = false"
        />
        <Button
          :label="editingId ? 'Atualizar' : 'Guardar'"
          icon="pi pi-check"
          class="p-button-success"
          :loading="saving"
          @click="save"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import ReceptionAccessoryService from "@/services/reception-accessory.service";

export default {
  name: "ReceptionAccessories",
  data() {
    return {
      accessories: [],
      loading: false,
      saving: false,
      showDialog: false,
      editingId: null,
      form: {
        name: "",
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;
        const response = await ReceptionAccessoryService.getAll();
        this.accessories = response?.data || response || [];
      } catch {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Erro ao carregar acessórios.",
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
    openNew() {
      this.form = { name: "" };
      this.editingId = null;
      this.showDialog = true;
    },
    openEdit(row) {
      this.form = { name: row.name };
      this.editingId = row.id;
      this.showDialog = true;
    },
    async save() {
      if (!this.form.name) {
        this.$toast.add({
          severity: "warn",
          summary: "Atenção",
          detail: "Nome é obrigatório.",
          life: 3000,
        });
        return;
      }

      try {
        this.saving = true;

        if (this.editingId) {
          await ReceptionAccessoryService.update(this.editingId, this.form);
          this.$toast.add({
            severity: "success",
            summary: "Sucesso",
            detail: "Acessório atualizado.",
            life: 3000,
          });
        } else {
          await ReceptionAccessoryService.create(this.form);
          this.$toast.add({
            severity: "success",
            summary: "Sucesso",
            detail: "Acessório criado.",
            life: 3000,
          });
        }

        this.showDialog = false;
        await this.fetchData();
      } catch (error) {
        const detail =
          error.response?.data?.code?.[0] ||
          error.response?.data?.name?.[0] ||
          "Erro ao guardar acessório.";
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail,
          life: 3000,
        });
      } finally {
        this.saving = false;
      }
    },
    confirmDelete(row) {
      this.$confirm.require({
        message: `Tem a certeza que pretende eliminar o acessório "${row.name}"?`,
        header: "Confirmar eliminação",
        icon: "pi pi-exclamation-triangle",
        acceptClass: "p-button-danger",
        acceptLabel: "Eliminar",
        rejectLabel: "Cancelar",
        accept: () => this.deleteAccessory(row),
      });
    },
    async deleteAccessory(row) {
      try {
        this.loading = true;
        await ReceptionAccessoryService.destroy(row.id);
        this.$toast.add({
          severity: "success",
          summary: "Eliminado",
          detail: "Acessório eliminado.",
          life: 3000,
        });
        await this.fetchData();
      } catch {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Erro ao eliminar acessório.",
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.card {
  padding: 2rem;
}

h1 {
  margin-bottom: 1.5rem;
  color: #495057;
}

.p-field label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
}
</style>
